/* DateLozenge.tsx generated by @compiled/babel-plugin v0.36.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "color", "children"];
import "./DateLozenge.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
var baseStyles = null;
var onClickStyles = null;
var colorStyles = {
  red: "_bfhk1vk5 _syaz9lu1 _irr31rtt",
  yellow: "_bfhk1ozg _syazfb2s _irr33fv2",
  blue: "_bfhkavxe _syazpnps _irr34v9p",
  green: "_bfhkn729 _syazh55r _irr31wnw",
  purple: "_bfhkp7j4 _syaz10m5 _irr31jkz",
  grey: "_bfhkm7j4 _syaz1fxt _irr315ej"
};
export var DateLozenge = function DateLozenge(props) {
  var className = props.className,
    _props$color = props.color,
    color = _props$color === void 0 ? 'grey' : _props$color,
    children = props.children,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement("span", _extends({}, rest, {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    className: ax(["_2rko1sit _19pkidpf _2hwxt94y _otyridpf _18u0t94y _v5641y8x _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66 _kqswh2mm _o5721q9c _80omn7od", props.onClick && "_80omtlke", colorStyles[color], className]),
    role: "button"
  }), children);
};